import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PREFACTURACIONES_LISTA, PREFACTURACIONES_NUEVOACTUALIZAR } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoActualizarPage from './nuevo-actualizar'

export default function PreFacturacionesPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PREFACTURACIONES_NUEVOACTUALIZAR}/:id`} component={NuevoActualizarPage} />
        <Route path={`/${PREFACTURACIONES_NUEVOACTUALIZAR}`} component={NuevoActualizarPage} />
        <Route path={`/${PREFACTURACIONES_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
